import { FC, PropsWithChildren } from 'react';
import { noop } from 'utils/noop';
import { PrimaryOptionText, PrimaryLinkStyled } from './QuickNav.styles';

export interface PrimaryLinkProps {
  /** Function to call when the mouse enters the link */
  onMouseEnter?: () => void;
  /** Displayed Link Text */
  title?: string;
  /** Link */
  href?: string;
  children?: JSX.Element;
}

export const PrimaryLink: FC<PropsWithChildren<PrimaryLinkProps>> = ({
  onMouseEnter = noop,
  title = '',
  href = '/',
  children,
  ...props
}: PrimaryLinkProps) => {
  return (
    <PrimaryLinkStyled
      href={href}
      target="_blank"
      rel="noopener"
      onMouseEnter={onMouseEnter}
      tabIndex={0}
      data-test="quick-nav-primarylink"
      {...props}
    >
      <PrimaryOptionText data-test="quick-nav-primarylink-text">{title}</PrimaryOptionText>
      {children}
    </PrimaryLinkStyled>
  );
};
